import React from 'react';
import './Blob.css';

const Blob = () => {
    return (
        <div className="blob__wrapper">
            <section>
                <div className="blob">
                    <svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="100%" id="blobSvg">
                        <defs>
                            <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                            <stop offset="0%" style={{stopColor: 'rgb(254, 0, 242)'}}></stop>
                            <stop offset="100%" style={{stopColor: 'rgb(251, 2, 128)'}}></stop>
                            </linearGradient>
                        </defs>
                        <path fill="url(#gradient)">
                            <animate attributeName="d" dur="10000ms" repeatCount="indefinite" values="M449,309.5Q414,369,362.5,402.5Q311,436,249,440Q187,444,157.5,391.5Q128,339,101,294.5Q74,250,101.5,206Q129,162,153.5,95Q178,28,248.5,32Q319,36,378,75Q437,114,460.5,182Q484,250,449,309.5Z;
                            
                            M409,295Q373,340,349.5,412.5Q326,485,250.5,482Q175,479,117,434Q59,389,32,319.5Q5,250,38,185Q71,120,122,67Q173,14,240,44Q307,74,344.5,114Q382,154,413.5,202Q445,250,409,295Z;
                            
                            M416,300Q387,350,348.5,391.5Q310,433,244.5,450.5Q179,468,129.5,421Q80,374,89,312Q98,250,90,189Q82,128,134,90Q186,52,244.5,70Q303,88,342,121.5Q381,155,413,202.5Q445,250,416,300Z;
                            
                            M416.5,298Q383,346,351,404.5Q319,463,255.5,445.5Q192,428,137.5,399.5Q83,371,66.5,310.5Q50,250,67.5,190Q85,130,139,102Q193,74,249,76.5Q305,79,341.5,118Q378,157,414,203.5Q450,250,416.5,298Z;
                            
                            M438,297Q380,344,348.5,400Q317,456,255,441Q193,426,121,411Q49,396,31.5,323Q14,250,66.5,202.5Q119,155,151,99.5Q183,44,244.5,61Q306,78,354.5,108.5Q403,139,449.5,194.5Q496,250,438,297Z; 
                            
                            M449,309.5Q414,369,362.5,402.5Q311,436,249,440Q187,444,157.5,391.5Q128,339,101,294.5Q74,250,101.5,206Q129,162,153.5,95Q178,28,248.5,32Q319,36,378,75Q437,114,460.5,182Q484,250,449,309.5Z"></animate>
                        </path>
                    </svg>
                </div>
                <div className="blob">
                    <svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="100%" id="blobSvg">
                        <defs>
                            <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                            <stop offset="0%" style={{stopColor: 'rgb(254, 0, 242)'}}></stop>
                            <stop offset="100%" style={{stopColor: 'rgb(251, 2, 128)'}}></stop>
                            </linearGradient>
                        </defs>
                        <path fill="url(#gradient)">
                            <animate attributeName="d" dur="10000ms" repeatCount="indefinite" values="M449,309.5Q414,369,362.5,402.5Q311,436,249,440Q187,444,157.5,391.5Q128,339,101,294.5Q74,250,101.5,206Q129,162,153.5,95Q178,28,248.5,32Q319,36,378,75Q437,114,460.5,182Q484,250,449,309.5Z;
                            
                            M409,295Q373,340,349.5,412.5Q326,485,250.5,482Q175,479,117,434Q59,389,32,319.5Q5,250,38,185Q71,120,122,67Q173,14,240,44Q307,74,344.5,114Q382,154,413.5,202Q445,250,409,295Z;
                            
                            M416,300Q387,350,348.5,391.5Q310,433,244.5,450.5Q179,468,129.5,421Q80,374,89,312Q98,250,90,189Q82,128,134,90Q186,52,244.5,70Q303,88,342,121.5Q381,155,413,202.5Q445,250,416,300Z;
                            
                            M416.5,298Q383,346,351,404.5Q319,463,255.5,445.5Q192,428,137.5,399.5Q83,371,66.5,310.5Q50,250,67.5,190Q85,130,139,102Q193,74,249,76.5Q305,79,341.5,118Q378,157,414,203.5Q450,250,416.5,298Z;
                            
                            M438,297Q380,344,348.5,400Q317,456,255,441Q193,426,121,411Q49,396,31.5,323Q14,250,66.5,202.5Q119,155,151,99.5Q183,44,244.5,61Q306,78,354.5,108.5Q403,139,449.5,194.5Q496,250,438,297Z; 
                            
                            M449,309.5Q414,369,362.5,402.5Q311,436,249,440Q187,444,157.5,391.5Q128,339,101,294.5Q74,250,101.5,206Q129,162,153.5,95Q178,28,248.5,32Q319,36,378,75Q437,114,460.5,182Q484,250,449,309.5Z"></animate>
                        </path>
                    </svg>
                </div>
            </section>
        </div>
    )
}

export default Blob
